import { type PollContentObjectDetail, type UploadedFile, createPollContentObjectDetail } from 'models';
import { useMutation } from 'query';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { useContentObjectCache } from 'features/feed/queries/cache';
import type { PollSubmitData } from '../../form/PollForm';
import { createPoll } from '../../services';

type CreatePollData = {
  attachments?: UploadedFile[];
  communityId?: string;
  htmlContent: string;
  pinned?: boolean;
  poll: PollSubmitData;
  textContent: string;
};

/**
 * @deprecated AI-generated code, not reviewed. Needs revision before further use — do not use as a reference or pattern to follow.
 */
export const useCreatePollMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<PollContentObjectDetail, CreatePollData>({
    async mutationFn({ attachments, communityId, htmlContent, pinned, poll, textContent }) {
      const response = await createPoll({
        /* eslint-disable @typescript-eslint/naming-convention -- key is defined by Backend API endpoint */
        body: {
          poll: {
            ...poll,
            attachments,
            community_id: communityId,
            description: textContent,
            html_description: htmlContent,
            pinned,
          },
        },
        /* eslint-enable @typescript-eslint/naming-convention -- key is defined by Backend API endpoint */
      });

      return createPollContentObjectDetail(response.data);
    },
    onSuccess(data) {
      cache.create(data);
    },
  });
};
